/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_View_Numbers_BodyInputs */

const en_platform_view_numbers_body = /** @type {(inputs: Platform_View_Numbers_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Measurements and lifts from every visit, with the change since day one.`)
};

const pl_platform_view_numbers_body = /** @type {(inputs: Platform_View_Numbers_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomiary i ciężary z każdej wizyty, z różnicą od startu.`)
};

/**
* | output |
* | --- |
* | "Measurements and lifts from every visit, with the change since day one." |
*
* @param {Platform_View_Numbers_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_view_numbers_body = /** @type {((inputs?: Platform_View_Numbers_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_View_Numbers_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_view_numbers_body(inputs)
	return en_platform_view_numbers_body(inputs)
});